/**
 * Auto-play budget (docs/design/2026-10-11-auto-play.md, DECISIONS_2026-10-11 "Auto-play answers"): 3 hours of auto a
 * real day, unused time banks up to 6 hours. Pure: the day number comes from dayReset.ts (`realDay`), time from the
 * World's step. Stored on the progress as `autoBudget`.
 */
export const AUTO_BUDGET = { dailySeconds: 3 * 3600, capSeconds: 6 * 3600 } as const;

export interface AutoBudget {
  /** The real day (dayReset.realDay) the bank was last topped up. */
  day: number;
  /** Seconds of auto left. */
  secs: number;
}

export const newAutoBudget = (day = 0): AutoBudget => ({ day, secs: AUTO_BUDGET.dailySeconds });

/** Tops the bank up for every real day passed since `day`, capped at the bank limit. A first sight of a day starts a full day. */
export function rollAutoBudget(b: AutoBudget, day: number): void {
  if (b.day === 0) {
    b.day = day; // made before the day was known: it is today's fresh allowance
    return;
  }
  if (day <= b.day) return;
  const n = day - b.day;
  b.day = day;
  b.secs = Math.min(AUTO_BUDGET.capSeconds, b.secs + n * AUTO_BUDGET.dailySeconds);
}

/** Spends `dt` seconds; returns the seconds left (0 when empty). */
export function drainAutoBudget(b: AutoBudget, dt: number): number {
  b.secs = Math.max(0, b.secs - dt);
  return b.secs;
}

export function parseAutoBudget(v: unknown): AutoBudget | undefined {
  if (!v || typeof v !== 'object') return undefined;
  const r = v as Record<string, unknown>;
  if (typeof r.day !== 'number' || typeof r.secs !== 'number' || !Number.isFinite(r.day) || !Number.isFinite(r.secs)) return undefined;
  return { day: Math.floor(r.day), secs: Math.min(AUTO_BUDGET.capSeconds, Math.max(0, r.secs)) };
}
